import { AlertOperators } from "@validereinc/domain";
import { convertMapToOpts } from "../shared/index.ts";
import { toTitleCaseString } from "@validereinc/utilities";

export const AlertOperatorOptions = convertMapToOpts(
  AlertOperators,
  ([_, value]) => toTitleCaseString(value)
);
